var map = {
	"./de/api.json": 7958,
	"./de/app.json": 8793,
	"./de/aspi.json": 353,
	"./de/attachments.json": 4448,
	"./de/beers.json": 2661,
	"./de/catalog.json": 7497,
	"./de/coffee.json": 4766,
	"./de/common.json": 8959,
	"./de/food.json": 6202,
	"./de/labels.json": 585,
	"./de/oil.json": 9754,
	"./de/onav.json": 7180,
	"./de/pairing.json": 6126,
	"./de/pdf.json": 9588,
	"./de/products.json": 7654,
	"./de/profile.json": 8939,
	"./de/reports.json": 1417,
	"./de/tea.json": 2392,
	"./de/vinegar.json": 8140,
	"./en/api.json": 4853,
	"./en/app.json": 6309,
	"./en/aspi.json": 5669,
	"./en/attachments.json": 4956,
	"./en/beers.json": 8065,
	"./en/catalog.json": 6581,
	"./en/coffee.json": 8266,
	"./en/common.json": 6251,
	"./en/food.json": 8590,
	"./en/labels.json": 1285,
	"./en/oil.json": 4006,
	"./en/onav.json": 9032,
	"./en/pairing.json": 7850,
	"./en/pdf.json": 7472,
	"./en/products.json": 8634,
	"./en/profile.json": 4263,
	"./en/reports.json": 3725,
	"./en/tea.json": 6356,
	"./en/vinegar.json": 9656,
	"./es/api.json": 441,
	"./es/app.json": 2134,
	"./es/aspi.json": 3352,
	"./es/attachments.json": 547,
	"./es/beers.json": 922,
	"./es/catalog.json": 6062,
	"./es/coffee.json": 6363,
	"./es/common.json": 6266,
	"./es/food.json": 8015,
	"./es/labels.json": 764,
	"./es/oil.json": 4153,
	"./es/onav.json": 8201,
	"./es/pairing.json": 5589,
	"./es/pdf.json": 2599,
	"./es/products.json": 63,
	"./es/profile.json": 4424,
	"./es/reports.json": 9826,
	"./es/tea.json": 1783,
	"./es/vinegar.json": 5451,
	"./fr/api.json": 6273,
	"./fr/app.json": 7454,
	"./fr/aspi.json": 8160,
	"./fr/attachments.json": 6123,
	"./fr/beers.json": 1522,
	"./fr/catalog.json": 4854,
	"./fr/coffee.json": 5587,
	"./fr/common.json": 2258,
	"./fr/food.json": 9447,
	"./fr/labels.json": 8932,
	"./fr/oil.json": 5329,
	"./fr/onav.json": 9505,
	"./fr/pairing.json": 8589,
	"./fr/pdf.json": 4671,
	"./fr/products.json": 3271,
	"./fr/profile.json": 7536,
	"./fr/reports.json": 2970,
	"./fr/tea.json": 3183,
	"./fr/vinegar.json": 3027,
	"./it/api.json": 752,
	"./it/app.json": 4091,
	"./it/aspi.json": 8051,
	"./it/attachments.json": 8078,
	"./it/beers.json": 8067,
	"./it/catalog.json": 3047,
	"./it/coffee.json": 5156,
	"./it/common.json": 8669,
	"./it/food.json": 8148,
	"./it/labels.json": 3023,
	"./it/oil.json": 7744,
	"./it/onav.json": 4942,
	"./it/pairing.json": 508,
	"./it/pdf.json": 8170,
	"./it/products.json": 1956,
	"./it/profile.json": 9633,
	"./it/reports.json": 6179,
	"./it/tea.json": 9658,
	"./it/vinegar.json": 6950,
	"./pt/api.json": 1517,
	"./pt/app.json": 858,
	"./pt/aspi.json": 8532,
	"./pt/attachments.json": 4439,
	"./pt/beers.json": 5134,
	"./pt/catalog.json": 2802,
	"./pt/coffee.json": 5071,
	"./pt/common.json": 2126,
	"./pt/food.json": 6971,
	"./pt/labels.json": 7104,
	"./pt/oil.json": 1757,
	"./pt/onav.json": 8381,
	"./pt/pairing.json": 4985,
	"./pt/pdf.json": 5243,
	"./pt/products.json": 7755,
	"./pt/profile.json": 3580,
	"./pt/reports.json": 7310,
	"./pt/tea.json": 9035,
	"./pt/vinegar.json": 207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1556;